// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/lang.ts"
);
import.meta.hot.lastModified = "1725260645555.139";
}
// REMIX HMR END

import { createPath, Params } from "@remix-run/react";
import SYS_CONFIG from "~/config";
import { SupportedLangs, LangDat } from "~/types/sys";

export const langByParam = (param: string | undefined | Params): LangDat => {
    const config = SYS_CONFIG.SUPPORTED_LANG_OBJECTS as LangDat[];

    let defaultCase = config[0];
    if (typeof param === 'string') {
        // console.log('is string')
        for (let i = 0; i < config.length; i += 1) {
            const entry = config[i];
            if (entry.default) defaultCase = entry;
            if (param === entry.lang_param) return { ...entry, didnt_match: false }
        }
        return { ...defaultCase, didnt_match: true }
    } else {
        for (let i = 0; i < config.length; i += 1) {
            const entry = config[i];
            if (entry.default) return { ...entry, didnt_match: false }
        }
    }
    return { ...defaultCase, didnt_match: true }
}

export const langByLangCode = (langCode: SupportedLangs): LangDat => {
    const config = SYS_CONFIG.SUPPORTED_LANG_OBJECTS as LangDat[];

    for (let i = 0; i < config.length; i += 1) {
        if (config[i].lang_code === langCode) return { ...config[i], didnt_match: false }
    }

    return { ...config[0], didnt_match: true }
}

export function replaceDoubleTrailingSlash(path: string) {
    //  console.log({ path })
    if (path.startsWith('//')) {
        // return path.replace('//', '/')

        return createPath({ pathname: path.replace('//', '/') })
    }
    return createPath({ pathname: path })
}


export const langSwitcher = (param: string | undefined | Params, path: string, targetLang: SupportedLangs): string => {
    const target = langByLangCode(targetLang);
    const target_lang_param = target.lang_param;

    let out = '';

    if (path === '/' && param === undefined) {
        out = replaceDoubleTrailingSlash(`/${target_lang_param}`)
    } else if (param === undefined) {
        out = replaceDoubleTrailingSlash(`/${target_lang_param}${path}`)
    } else if (target_lang_param === '') {
        out = replaceDoubleTrailingSlash(path.replace(`/${param}`, `/${target_lang_param}`))
    } else {
        out = replaceDoubleTrailingSlash(path.replace(`/${param}`, `/${target_lang_param}`))
    }

    if (out.endsWith('/')) out = out.substring(0, out.length - 1);

    return createPath({ pathname: out })
}

export const createLangPathByParam = (
    param: string | undefined,
    path: string) => {

    let out = ''




    if (param && SYS_CONFIG.SUPPORTED_LANGS.includes(param as SupportedLangs)) {
        out = `/${param}${path}`
    } else {
        out = path
    }

    if (out.endsWith('/')) out = out.substring(0, out.length - 1);

    return createPath({ pathname: out })
}

export const cutLangSegmentFromPath = (path: string): string => {
    for (let i = 0; i < SYS_CONFIG.SUPPORTED_LANG_OBJECTS.length; i += 1) {
        if (!SYS_CONFIG.SUPPORTED_LANG_OBJECTS[i].default) {
            if (path.startsWith(`/${SYS_CONFIG.SUPPORTED_LANG_OBJECTS[i].lang_param}/`)) {
                return path.replace(`/${SYS_CONFIG.SUPPORTED_LANG_OBJECTS[i].lang_param}`, '')
            } else if (path === `/${SYS_CONFIG.SUPPORTED_LANG_OBJECTS[i].lang_param}`) {
                return path.replace(SYS_CONFIG.SUPPORTED_LANG_OBJECTS[i].lang_param, '')
            }
        }

    }
    return path
}